// @flow
import { words, camelCase, toLower, padStart } from 'lodash';

const zeroPad = (value: number, digits: number): number => {
  const numberAsString = value.toString();

  return numberAsString.length > 1 ? numberAsString : '0' + numberAsString;
};

const sliceHtml = content => {
  let paragraph = document.createElement('p');
  paragraph.innerHTML = content;
  return paragraph.textContent || paragraph.innerText || '';
};

const formatDescription = (value, string_length): string => {
  let paragraph = sliceHtml(value);
  var extracted_str = words(paragraph, /[^ ]+/g);
  var string_sentence = '';
  let count;
  if (string_length > extracted_str.length) count = extracted_str.length;
  else count = string_length;
  for (let i = 0; i < count; i++) {
    extracted_str[i] += ' ';
    string_sentence = string_sentence.concat(extracted_str[i]);
  }
  return string_sentence;
};

const camelCaseString = (str: string): string => {
  return camelCase(str);
};

const lowerCaseString = (str: string): string => {
  return toLower(str);
};

const regexPatterns = {
  phone1: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  phone: /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/,
  phoneINDUS: /^[0-9]{10}$/,
  phoneOMSG: /^[0-9]{8}$/,
  phoneUK: /^[0-9]{11}$/,
  phoneAUS: /^[0-9]{9}$/,
};

const sortString = (key, order = 'desc') => {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }
    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
};

const compareValues = (key, order = 'desc') => {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
    const comparison = a[key].localeCompare(b[key]);

    return order === 'desc' ? comparison * -1 : comparison;
  };
};

const checkBoolean = key => {
  return key === 'Yes';
};

export const StringUtil = {
  camelCaseString,
  lowerCaseString,
  formatDescription,
  regexPatterns,
  sliceHtml,
  zeroPad,
  sortString,
  compareValues,
  checkBoolean,
};
